import SectionHeading from '@/pages/home/components/SectionHeading';
import { focusArchive, timelineEvents } from '@/mocks/home';

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <SectionHeading
          eyebrow="Thread"
          title="事件脉络：从起因到最新回应"
          desc="以当前热度最高的人物档案为例，把散落在各处的说法按时间顺序串成一条线，每个节点都标注信源数量，方便逐条回溯。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:sticky lg:top-24">
              <span className="font-label text-xs tracking-[0.2em] text-primary-600">
                当前追踪档案
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                {focusArchive.name}
              </h3>
              <p className="mt-1 font-label text-xs text-foreground-500">
                {focusArchive.code} · {focusArchive.category}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                {focusArchive.summary}
              </p>
              <dl className="mt-5 grid grid-cols-3 gap-3 border-t border-background-300/60 pt-5">
                <div className="flex flex-col items-center">
                  <dt className="font-label text-[11px] text-foreground-500">关键节点</dt>
                  <dd className="mt-1 font-heading text-lg font-bold text-foreground-950">7</dd>
                </div>
                <div className="flex flex-col items-center border-x border-background-300/60">
                  <dt className="font-label text-[11px] text-foreground-500">收录信源</dt>
                  <dd className="mt-1 font-heading text-lg font-bold text-accent-600">12</dd>
                </div>
                <div className="flex flex-col items-center">
                  <dt className="font-label text-[11px] text-foreground-500">持续天数</dt>
                  <dd className="mt-1 font-heading text-lg font-bold text-foreground-950">6</dd>
                </div>
              </dl>
              <p className="mt-4 rounded-md bg-secondary-100 px-3 py-2.5 text-xs leading-relaxed text-secondary-900">
                归档原则：只说清「谁在什么时间说了什么」，不替任何一方下结论。
              </p>
            </div>
          </aside>

          <ol className="relative lg:col-span-8">
            {timelineEvents.map((event, index) => (
              <li key={event.title} className="relative flex gap-4 md:gap-5">
                <div className="flex flex-col items-center">
                  <span
                    className={`mt-1.5 flex h-3 w-3 shrink-0 items-center justify-center rounded-full ring-4 ring-background-100 ${
                      index === 0 ? 'bg-accent-500' : 'bg-foreground-300'
                    }`}
                  />
                  {index < timelineEvents.length - 1 ? (
                    <span className="w-px flex-1 bg-background-300" />
                  ) : null}
                </div>
                <div className={index < timelineEvents.length - 1 ? 'flex-1 pb-8' : 'flex-1'}>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-label text-xs tracking-wide text-foreground-500">
                      {event.date}
                    </span>
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-label text-[11px] text-accent-900">
                      {event.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {event.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{event.desc}</p>
                  <span className="mt-2.5 inline-flex items-center gap-1.5 font-label text-xs text-foreground-500">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-links-line text-sm" />
                    </span>
                    已收录 {event.sources} 条信源
                  </span>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}